import { useMediaQuery } from '@mui/material'
import { useRouter } from 'next/router'
import { SnackbarProvider } from 'notistack'
import { ReactNode, useMemo } from 'react'
import { BOTTOM_NAVIGATION_HEIGHT } from '~/components/layout/AppLayout/AppBottomNavigation'
import { excludePathes } from '~/contexts/AuthContext'
import { snackActions, SnackbarUtilsConfigurator } from '~/lib/snackbarHelper'
import { theme } from '~/lib/theme'

export const AppSnackbarProvider = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const router = useRouter()

  const isAuthPage = useMemo(() => excludePathes.some((path) => router.pathname.startsWith(path)), [router.pathname])

  const bottomInset = isMobile && !isAuthPage ? BOTTOM_NAVIGATION_HEIGHT : 0

  return (
    <SnackbarProvider
      maxSnack={5}
      SnackbarProps={{
        onClick: () => snackActions.dismiss,
      }}
      autoHideDuration={3000}
      preventDuplicate
      classes={{
        containerAnchorOriginBottomLeft: 'snackbar-container',
      }}
    >
      <SnackbarUtilsConfigurator />
      {children}

      <style jsx global>{`
        .snackbar-container {
          margin-bottom: calc(env(safe-area-inset-bottom) + ${bottomInset}px - 6px);
        }
      `}</style>
    </SnackbarProvider>
  )
}
